import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AuthFeatureState } from '.';
import { FEATURE_NAME } from './state';

export const authFeatureSelector = createFeatureSelector<AuthFeatureState>(FEATURE_NAME);
export const authSelector = createSelector(authFeatureSelector, (state: AuthFeatureState) => state.auth);
export const isAuthenticated = createSelector(authSelector, (state) => state.isAuthenticated);
